import { Modal, ModalId } from "../../../../../features/ui";
import { Customer } from "../../..";
import { Address, addressHelpers } from "../../../../../features/address";
import { useActions } from "./actions";

type Props = {
    customer?: Customer
    address?: Address
    onSubmit: (customer: Customer) => void
}

export const UpdateCustomerAddressModal = (props: Props) => {
    const { customer, address, onSubmit } = props

    const { updateCustomerAddress } = useActions()

    const { describeAddress } = addressHelpers

    const renderBody = () => customer && address ? <div>
        Se utilizará la dirección <strong>{describeAddress(address)}</strong> para emitir la factura.
        ¿Desea actualizar el cliente con este domicilio?
    </div> : <></>

    const onUpdate = async () => {
        const updatedCustomer = await updateCustomerAddress(customer!.id, address!)
        onSubmit(updatedCustomer)
    }

    return (
        <Modal
            modalId={ModalId.UPDATE_CUSTOMER_ADDRESS}
            title="Actualizar Domicilio del Cliente"
            submitLabel="Actualizar Cliente"
            cancelLabel="Continuar sin Actualizar"
            onSubmit={onUpdate}
        >
            {renderBody()}
        </Modal>
    )
}
